export const ukAboutText = (
  <div className="text1">
    <p>
      <b>ProTax Advisors — Your Trusted Accounting Partner</b>
    </p>
    <p>We look after your numbers, so you can grow your business.</p>
    <p>
      Welcome to ProTax Advisors, where managing your finances becomes simple,
      stress-free, and efficient. Based in London and Bedfordshire, we
      specialise in helping startups, freelancers, and small-to-medium
      businesses stay on top of their numbers — so you can focus on growing your
      business.
    </p>
    <p>
      Our team is fully qualified and certified, with professional
      accreditations in accounting, taxation, and bookkeeping. We combine
      technical expertise with a personalised approach to deliver accurate,
      compliant, and reliable financial services tailored to your business
      needs.
    </p>
    <p>
      At ProTax Advisors, we do more than manage your accounts — we provide
      clear guidance and practical advice to help your business thrive. From
      bookkeeping, payroll, and tax compliance to budgeting, forecasting, and
      financial planning, our qualified accountants ensure your finances are in
      order and your business is positioned for growth.
    </p>
    <p>When you work with ProTax Advisors, you benefit from:</p>
    <ul>
      <li>
        Qualified, certified accountants who understand the complexities of
        business finance
      </li>
      <li>
        Personalised support tailored to your business goals and reporting needs
      </li>
      <li>Transparent, fixed pricing with no hidden costs</li>
      <li>
        Modern digital tools for efficient, real-time access to your financial
        data
      </li>
      <li>
        Let us handle the numbers — so you can focus on building and growing
        your business with confidence.
      </li>
    </ul>
  </div>
);
